import PremiumVersionIcon from "@/components/PremiumVersionIcon";
import ShopDTO from "@/dto/shop/ShopDTO";
import { useGlobalStore } from "@/store/hooks";
import { isEmpty } from "@/utils";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";

interface SplitOrderMenuItemProps {
    shop: ShopDTO;

    favoriteNode?: React.ReactNode;
}

const SplitOrderMenuItem: React.FC<SplitOrderMenuItemProps> = function (props) {
    const { shop, favoriteNode } = props;

    const store = useGlobalStore();

    const shopId = shop?.id;

    useEffect(() => {
        store.premiumFeatureTrialStore.getNodePremiumFeatureTrial([shopId]);
    }, [shopId]);

    const premiumFeatureTrial = store.premiumFeatureTrialStore.premiumFeatureTrialMapping.get(shopId);

    return (
        <div className="ec-other-operation-menu-item">
            <span className="ec-other-operation-menu-item-label">
                {store.premiumFeatureTrialStore.loading && (
                    <Spin indicator={<LoadingOutlined style={{ color: "#fff", marginRight: "10px" }} />} />
                )}
                拆分订单
                {!isEmpty(premiumFeatureTrial?.ORDER_SPLITTING) ? (
                    <span className="text-error small">(可试用{premiumFeatureTrial.ORDER_SPLITTING}次)</span>
                ) : null}
            </span>
            <PremiumVersionIcon />
            {favoriteNode}
        </div>
    );
};

export default observer(SplitOrderMenuItem);
